import { Grid } from '@mui/material'

import { Issue } from './Issue'
import { DeleteIssue, toIssues } from './to-issues'

interface IssueListProps {
  rejections: DeleteIssue[]
  warnings: DeleteIssue[]
  deletedItemString: string
  scope: string
}

export function IssueList(props: IssueListProps) {
  return (
    <Grid container spacing={1}>
      {toIssues(props.rejections).map((rejection, index) => (
        <Grid item key={index} xs={12}>
          <Issue
            kind='rejection'
            value={rejection.value}
            uuids={rejection.uuids}
            isOtherShop={rejection.isOtherShop}
            deletedItemString={props.deletedItemString}
            scope={props.scope}
          />
        </Grid>
      ))}
      {toIssues(props.warnings).map((warning, index) => (
        <Grid item key={index} xs={12}>
          <Issue
            kind='warning'
            value={warning.value}
            uuids={warning.uuids}
            isOtherShop={warning.isOtherShop}
            deletedItemString={props.deletedItemString}
            scope={props.scope}
          />
        </Grid>
      ))}
    </Grid>
  )
}
